import { FC, useEffect } from 'react';
import { OnboardingLinkPage } from '@/__generated__/graphql.ts';
import { ReCreateStripeAccount } from '@/components/stripe-account/re-create-stripe-account.tsx';
import {
  StripeAccountCreated,
  StripeAccountCreatedFallback,
} from '@/components/stripe-account/stripe-account-created.tsx';
import { StripeDetailsSubmitted } from '@/components/stripe-account/stripe-details-submitted.tsx';
import { useCreateStripeSellerAccount } from '@/components/stripe-account/use-create-stripe-seller-account.ts';
import { StripeAccountStatus } from '@/components/stripe-account/use-stripe-account-status.ts';

export const SetupStripeAccountModalContent: FC<{
  stripeAccountStatus: StripeAccountStatus;
  onClose: () => void;
  redirectTo: OnboardingLinkPage;
}> = ({ onClose, stripeAccountStatus, redirectTo }) => {
  const [createStripeSellerAccount, { loading, error }] =
    useCreateStripeSellerAccount();

  useEffect(() => {
    if (stripeAccountStatus === StripeAccountStatus.NotCreated)
      createStripeSellerAccount();
  }, [stripeAccountStatus, createStripeSellerAccount]);

  if (loading) {
    return <StripeAccountCreatedFallback />;
  }

  if (error) {
    return (
      <ReCreateStripeAccount
        onCreate={createStripeSellerAccount}
        loading={loading}
      />
    );
  }

  return stripeAccountStatus === StripeAccountStatus.DetailsSubmitted ? (
    <StripeDetailsSubmitted onClose={onClose} redirectTo={redirectTo} />
  ) : stripeAccountStatus === StripeAccountStatus.Created ? (
    <StripeAccountCreated redirectTo={redirectTo} />
  ) : null;
};
